import { BackendFormErrorResponse } from '@/core/types/Errors.ts'

export const isNumber = (val: number | string) =>
  /^-?\d+(\.\d+)?$/.test(String(val))

export const isNumberPositiveDecimalIncluding0 = (val: number | string) =>
  /^(?:0|[1-9]\d*)(?:\.\d+)?$/.test(String(val))

export const isPositiveNumber = (val: number | string) =>
  /^\d+(\.\d+)?$/.test(String(val))

export const isNameValid = (name: string) => /^[a-zA-ZñÑ ]*$/.test(name)

export const isNumberPositiveInteger = (value: string) =>
  /^[1-9]\d*$/.test(value)

export const isNumberPositiveIntegerIncluding0 = (value: string) =>
  /^[0-9]\d*$/.test(value)

export function isFormValidationError(
  response: any
): response is BackendFormErrorResponse {
  return (
    response &&
    typeof response === 'object' &&
    'data' in response &&
    typeof response.data === 'object' &&
    response.data !== null &&
    'error' in response.data &&
    typeof response.data.error === 'object' &&
    response.data.error !== null
  )
}
